// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ec9fa66d","171":"c78f51c9","378":"90c84a81"}[chunkId] + ".chunk.js";
};